import {Dispatch} from 'redux';
import {DATETABS_SET_TABS} from 'store/actionTypes';
import {DateTab} from 'utils/types';
import {DateTabsSetAction} from '../types';

// TODO: documentation

const setDateTabs = (tabs: DateTab[]) => (dispatch: Dispatch<DateTabsSetAction>): void => {
  dispatch({
    type: DATETABS_SET_TABS,
    payload: {tabs},
  });
};

export default setDateTabs;
